import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui'
import Cookies from 'js-cookie'
import {clearData} from '../store/modules/clearData'
import { getToken } from '@/utils/auth'

import {
  baseURL
} from '../config/config'

// axios 配置
const service = axios.create({
  timeout: 0,             // 请求的超时时间
  withCredentials: true,  // 允许携带cookie
  baseURL: baseURL,
});

service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
service.interceptors.request.use((config) => {
  // 携带Token
  getToken() ? config.headers.Authorization = 'Bearer ' + getToken() : null;

  return config;
}, (error) => {
  console.log('err' + error)// for debug
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })

  return Promise.reject(error);
});
// 响应拦截器状态判断
service.interceptors.response.use((res) => {
    return res;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 600:
          clearData();
          Message({
            message: '用户已过期，请重新登录',
          })
      }
    }
    return Promise.reject(error);
  });

export default service






// WEBPACK FOOTER //
// ./src/utils/service.js